import { render, staticRenderFns } from "./blog-4.vue?vue&type=template&id=44b45839&scoped=true"
import script from "./blog-4.vue?vue&type=script&lang=js"
export * from "./blog-4.vue?vue&type=script&lang=js"
import style0 from "./blog-4.vue?vue&type=style&index=0&id=44b45839&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b45839",
  null
  
)

export default component.exports